// The order pipeline in the order it happens. Cancelled sits outside it.
export const ORDER_STATUS_FLOW = [
  'New Order',
  'Ready for Kitting',
  'Kitting in Progress',
  'Ready for Shipping',
  'Shipping in Progress',
  'Order in Transit',
  'Order Delivered',
];

export const ORDER_STATUS_SHORT: Record<string, string> = {
  'New Order': 'New',
  'Ready for Kitting': 'Ready to kit',
  'Kitting in Progress': 'Kitting',
  'Ready for Shipping': 'Ready to ship',
  'Shipping in Progress': 'Shipping',
  'Order in Transit': 'In transit',
  'Order Delivered': 'Delivered',
};

export const ORDER_STATUS_CANCELLED = 'Cancelled';
